/*
 * @Description:
 * @Date: 2024-03-15 13:09:27
 */
import { XrkMessage, createDialog, BaseTextContent } from 'xrk-components';
import _DrugFormVue from './drug-form.vue';
import { Drug } from '../../data-source/types';
import { ref } from 'vue';
import {
  addProduct,
  updateProduct,
  uploadProductImg
} from '../../data-source/api';
import { PRODUCT_DRUG } from '../../config';
import { useZsStore } from '../../store';

export const DrugFormVue = _DrugFormVue;

export const createDrugFormDialog = (
  row: Partial<Drug['row']>,
  type: 'add' | 'edit' | 'preview',
  callback?: any
) => {
  const { enterpriseId } = useZsStore();
  const FormRef = ref();
  const typeStr = {
    add: '新增',
    edit: '编辑',
    preview: '查看'
  }[type];
  createDialog({
    width: 520,
    title: `${typeStr}药品`,
    contentRender: () => (
      <BaseTextContent>
        <DrugFormVue
          isAdd={type === 'add'}
          disabled={type === 'preview'}
          row={Object.freeze({ ...row })}
          ref={FormRef}
        ></DrugFormVue>
      </BaseTextContent>
    ),
    showFooter: type != 'preview',
    showClose: true,
    confirmBtnConfig: {
      show: true,
      type: 'primary',
      content: '保存'
    },
    cancelBtnConfig: { show: true, type: 'default', content: '取消' },
    beforeConfirm: async done => {
      const key = 'fileUrl';
      const fileKey = `file_${key}`;
      const res = await FormRef.value?.getFormData?.();
      if (typeof res[fileKey] === 'object') {
        const {
          data: { fileUrl }
        } = await uploadProductImg({ file: res[fileKey] });
        res[fileKey] = fileUrl;
      }
      if (type === 'add') {
        await addProduct({
          type: PRODUCT_DRUG,
          enterpriseId: enterpriseId.value,
          ...res,
          [key]: res[fileKey] || res[key]
        });
      } else {
        await updateProduct({
          type: PRODUCT_DRUG,
          enterpriseId: enterpriseId.value,
          ...res,
          [key]: res[fileKey] || res[key]
        });
      }
      callback?.();
      done();
      XrkMessage.success('操作成功');
    }
  });
};
